<template>
  <section class="final-message">
    <div
      v-for="(message, index) in messages"
      v-if="message.type == 'msg'"
      :key="index"
      class="input-wrapper"
      v-html="message.text"
    />
    <div
      v-for="(message, index) in messages"
      v-if="message.type == 'link'"
      :key="index"
      class="input-wrapper"
    >
      <a
        target="_blank"
        class="donation-nav donation-nav--block"
        :href="message.href"
      >{{ message.text }} </a>
    </div>
    <ul class="wrap-share-buttons">
      <li>
        <a
          class="twitter"
          target="_blank"
          :href="'https://twitter.com/intent/tweet?hashtags=VotoLegal&twitter&text=Eu%20apoiei%20'+ candidate.popular_name +',%20apoie%20você%20também!%20https%3A%2F%2Fvotolegal.com.br%2Fem%2F'+ candidate.username +''"
        />
      </li>
      <li>
        <a
          target="_blank"
          :href="'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fvotolegal.com.br%2Fem%2F'+ candidate.username +'&amp;src=sdkpreparse'"
          class="fb-xfbml-parse-ignore facebook"
        />
      </li>
    </ul>
    <a
      class="donation-nav donation-nav--rewind"
      href="#"
      @click.prevent="goBack"
    >deseja doar novamente?</a>
  </section>
</template>

<script>
export default {
	name: 'FinalMessage',
	computed: {
		messages() {
			return this.$store.state.messages;
		},
		candidate() {
			return this.getMergeCandidate.candidate;
		},
		getMergeCandidate() {
			return this.$store.getters.generateCandidateObject;
		},
	},
	mounted() {
		this.scrollToDonate();
	},
	methods: {
		scrollToDonate() {
			const form = document.getElementById('doar');
			form.scrollIntoView({ block: 'start', behavior: 'smooth' });
		},
		goBack() {
			this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'selectValue' });
		},
	},
}
</script>



// WEBPACK FOOTER //
// _source/javascript/components/steps/finalMessage.vue